export default __webpack_public_path__ + "static/20-66012d3944bbce363663c3179746de89.webp";